import React, { useState, useEffect } from 'react';
import Radio from '../FormsComponents/Radio';
import Input from '../FormsComponents/Input';

const Question = ({ question, data, onChange }) => {
  const [value, setValue] = useState('');

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    //  Se envia evento para notificar que esta pregunta se desplego
    window.dataLayer.push({
      'event': 'ev_view_screen',
      'data': {
        'screen': {
          'id': question.id,
          'name': question.description,
        }
      }
    });

    setValue('');
  }, [question.id, question.description]);

  const updateValue = (newValue) => {
    setValue(newValue);
    data[question.id] = newValue;
    onChange({ ...data });
  }

  const updateInputValue = (newValue) => {
    data[question.inputOptions.id] = parseInt(newValue);
    onChange({ ...data });
  }

  const getContent = () => {
    switch (question.type) {
      case 'radio':
        return <Radio element={question} value={data[question.id]} onChange={updateValue} />;
      case 'input':
        return <Input element={question} value={data[question.id]} onChange={updateValue} />;
      default:
        return null;
    }
  }

  return <div id={`question-${question.id}`}>
    <div className="questionsContent">
      <div className="questionTittle">
        {question.description}
        {question.help !== undefined && <div className="tooltip">
          <img src="https://www.nacion.com/gnfactory/especiales/2021/calculadora-renta-global-dual/images/question_calc.svg" alt="Calculator Icon" style={{ margin: '0px 0px -2px 6px', cursor: 'pointer' }} />
          <span className="tooltiptext">{question.help}</span>
        </div>}
      </div>
      <div className="answer">
        {getContent()}
        {question.hasInput && data[question.id] !== undefined && data[question.id] === question.inputOptions.showONValue &&
          <div className="questionMount">
            <p className="questionTittle">{question.inputOptions.description}</p>
            <Input element={question.inputOptions} value={data[question.inputOptions.id]} onChange={updateInputValue} />
          </div>
        }
      </div>
    </div>
  </div>;
}

export default Question;